import { render, staticRenderFns } from "./BlogPostParagraphsGallery.vue?vue&type=template&id=f5b936c8&scoped=true"
import script from "./BlogPostParagraphsGallery.vue?vue&type=script&lang=js"
export * from "./BlogPostParagraphsGallery.vue?vue&type=script&lang=js"
import style0 from "./BlogPostParagraphsGallery.vue?vue&type=style&index=0&id=f5b936c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5b936c8",
  null
  
)

export default component.exports